import React, {Component} from 'react';
const SRC_IFRAME = process.env.CDN_URL + "/ads/themoneytizer/banners/iframe-src-skyscraper.html"

export default class Skyscraper extends Component {

    constructor(props) {
        super(props);

        this.state = {
            hashId: Math.random()
        }

    }

    renderBannerDev() {
        return (
            <div className="themoneytizer-banner-dev themoneytizer-banner themoneytizer-skyscraper">
                <strong>{"ADS BANNER SKYSCRAPER"}</strong>
                <br/>
                {this.props.onlyDesktop && !this.props.onlyMobile && "onlyDesktop"}{" "}
                {this.props.onlyMobile && !this.props.onlyDesktop && "onlyMobile"}{" "}
                {this.props.onlyMobile && this.props.onlyDesktop && "Mobile & Desktop"}
                {!this.props.onlyMobile && !this.props.onlyDesktop && "Mobile & Desktop"}
                <br/>{this.props.sticky && "Sticky"}
            </div>
        );
    }

    render() {
        if (this.props.showDevBanner) {
            return this.renderBannerDev();
        }

        return (
            <div className="themoneytizer-banner themoneytizer-skyscraper lazy-loading-container-1">
                <iframe name="iframe_skyscraper" loading="lazy" className="lazy-loading-1"
                        src={SRC_IFRAME} themoneytizer-lazy={SRC_IFRAME}/>
            </div>
        );
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState) {
    }
}
